import React from 'react';
import { SmileIcon, FrownIcon, MehIcon, AngryIcon } from 'lucide-react';
import { BookCover } from './BookCover';
import { volumes } from '../../data/landing';
type MegapackMockupProps = {
  showBadge?: boolean;
  className?: string;
};
const fan = [{
  left: '0%',
  rotate: -11,
  y: '9%',
  z: 1
}, {
  left: '14.5%',
  rotate: -6.5,
  y: '3%',
  z: 2
}, {
  left: '29%',
  rotate: -2,
  y: '0%',
  z: 3
}, {
  left: '45%',
  rotate: 2,
  y: '0%',
  z: 3
}, {
  left: '59.5%',
  rotate: 6.5,
  y: '3%',
  z: 2
}, {
  left: '74%',
  rotate: 11,
  y: '9%',
  z: 1
}];
export function MegapackMockup({
  showBadge = true,
  className = ''
}: MegapackMockupProps) {
  return <div className={`relative mx-auto aspect-[16/10] w-full max-w-5xl ${className}`} role="img" aria-label="Megapack con 6 tomos temáticos, fichas imprimibles y acceso en tablet y celular" data-id="element-127" data-mp="2hy8eg5bcahw2">
      {/* Volumes fanned */}
      {volumes.map((v, i) => <div key={v.number} className="absolute top-[4%] w-[26%]" style={{
      left: fan[i].left,
      transform: `translateY(${fan[i].y}) rotate(${fan[i].rotate}deg)`,
      zIndex: fan[i].z
    }} data-id="element-128" data-mp="11ki6uol0hbho" data-mpi={i}>
          <BookCover eyebrow={`Tomo ${v.number}`} title={v.title} color={v.color} deep={v.deep} icon={v.icon} size="hero" data-id="element-129" data-mp="39czksf2lbpmi" />
        </div>)}

      {/* Printed worksheet */}
      <div className="absolute bottom-[1%] left-[10%] z-10 w-[19%] -rotate-6 rounded-[3%] bg-white p-[1.6%] shadow-[0_16px_28px_-14px_rgba(34,48,47,0.45)]" data-id="element-130" data-mp="2zlms5l8ywvff">
        <div className="mb-[8%] h-[5px] w-2/3 rounded-full bg-[#F4D3C1] sm:h-2" data-id="element-131" data-mp="2qn11f2tcea3k" />
        <div className="grid grid-cols-2 gap-[6%]" data-id="element-132" data-mp="2vl2v0hoe9rta">
          {[SmileIcon, FrownIcon, MehIcon, AngryIcon].map((Icon, i) => <div key={i} className="flex aspect-square items-center justify-center rounded-[12%] bg-cream" data-id="element-133" data-mp="2gp3ecin7yjcj" data-mpi={i}>
              <Icon className="h-[55%] w-[55%] text-ink/60" strokeWidth={1.5} aria-hidden="true" data-id="element-134" data-mp="2lltut72xrgyh" />
            </div>)}
        </div>
        <div className="mt-[8%] space-y-[6%]" data-id="element-135" data-mp="22kcx6pww7007">
          <div className="h-[3px] rounded-full bg-line sm:h-1" data-id="element-136" data-mp="1xqs4nde2iy8e" />
          <div className="h-[3px] w-4/5 rounded-full bg-line sm:h-1" data-id="element-137" data-mp="1ssgwd73f8vsa" />
        </div>
      </div>

      {/* Tablet with index */}
      <div className="absolute bottom-0 left-1/2 z-20 w-[40%] -translate-x-1/2 rounded-[5%] bg-ink p-[1.2%] shadow-[0_24px_40px_-18px_rgba(34,48,47,0.6)]" data-id="element-138" data-mp="1nuf4bwo0pm4o">
        <div className="flex aspect-[4/3] flex-col rounded-[3.5%] bg-paper p-[5%]" data-id="element-139" data-mp="2lf1mk485v1u9">
          <span className="font-serif text-[8px] leading-none text-ink sm:text-sm md:text-lg" data-id="element-140" data-mp="2gg87i7d872rz">Índice por objetivo</span>
          <div className="mt-[5%] flex flex-1 flex-col justify-between" data-id="element-141" data-mp="26k55r2mad65k">
            {volumes.map(v => <div key={v.number} className="flex items-center gap-[4%] rounded-[6px] px-[3%] py-[1.5%]" style={{
            backgroundColor: v.color
          }} data-id="element-142" data-mp="103t7l1jgro9z">
                <span className="text-[5px] font-bold sm:text-[8px] md:text-[10px]" style={{
              color: v.deep
            }} data-id="element-143" data-mp="v3evn8eqru6o">
                  T{v.number}
                </span>
                <span className="truncate text-[5px] font-semibold text-ink sm:text-[9px] md:text-xs" data-id="element-144" data-mp="3bqvbkd7cv956">{v.title}</span>
              </div>)}
          </div>
        </div>
      </div>

      {/* Phone */}
      <div className="absolute bottom-0 right-[15%] z-20 w-[10%] rounded-[16%] bg-ink p-[0.7%] shadow-[0_20px_32px_-14px_rgba(34,48,47,0.6)]" data-id="element-145" data-mp="3lhhhtgt6mnb7">
        <div className="flex aspect-[9/19] flex-col gap-[6%] rounded-[13%] bg-paper p-[12%]" data-id="element-146" data-mp="3qidn9yt6mhiq">
          <div className="h-[3px] w-3/4 rounded-full bg-ink/70 sm:h-1.5" data-id="element-147" data-mp="3ug31jfae48dk" />
          <div className="grid flex-1 grid-cols-2 content-start gap-[8%]" data-id="element-148" data-mp="3cwef88ndhq3">
            {volumes.map(v => <div key={v.number} className="aspect-[3/4] rounded-[12%]" style={{
            backgroundColor: v.color
          }} data-id="element-149" data-mp="8a63gms4jrde" />)}
          </div>
        </div>
      </div>

      {/* Bonus badge */}
      {showBadge && <div className="absolute -right-[1%] -top-[2%] z-30 flex aspect-square w-[17%] max-w-[136px] rotate-[10deg] flex-col items-center justify-center rounded-full bg-accent text-white shadow-[0_14px_26px_-12px_rgba(147,74,42,0.8)] ring-4 ring-cream" data-id="element-150" data-mp="2a45d73plm0nz">
          <span className="font-serif text-[18px] leading-none sm:text-4xl md:text-5xl" data-id="element-151" data-mp="ddfau6yxap35">+5</span>
          <span className="mt-0.5 text-[6px] font-extrabold uppercase tracking-[0.14em] sm:text-[10px] md:text-xs" data-id="element-152" data-mp="9cljt4q6ou61">Bonos</span>
          <span className="text-[5px] font-semibold uppercase tracking-[0.12em] opacity-90 sm:text-[8px] md:text-[10px]" data-id="element-153" data-mp="3ht6ls1keemzn">incluidos</span>
        </div>}
    </div>;
}